import { useSelector } from "react-redux";
import CloseIcon from "mdi-react/CloseIcon";
import { Avatar, Grid, Typography, Button } from "@material-ui/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import Row from "components/Row";
import Col from "components/Col";
import { firestoreRef } from "api";
import Page from "components/Page";
import ProfilePic from "./ProfilePic";
import styled from "styled-components";
import Card from "components/Card/Card";
import { Title } from "components/Title";
import Separator from "components/Separator";
import { Input } from "components/Inputs/Input";
import { Container, WalletButton, FancyLabel, TransactionCard } from "./styled";
import Modal, { useModal } from "components/Modal";
import { TopBarContext } from "layouts/DashboardLayout";
import VerticalSeparator from "components/VerticalSeparator";
import { SubTitle } from "components/headerBanner/HeaderBanner";
import { PrimaryButton } from "components/Buttons/PrimaryButton";
import FullScreenLoader from "components/Loaders/FullScreenLoader";
import { PresentPage } from "components/headerBanner/HeaderBanner";
import { BannerContainer } from "components/headerBanner/HeaderBanner";
import color from "../../config/color.js";
// import TopResult from "modules/result/topResults/TopResult";
// import PerformanceVisualization from "./PerformanceVisualization";

import {
  isVerified,
  getTransactions,
  updateProfileData,
  uploadImageToStorage
} from "./firebase";

function Profile({ history }) {
  const [user, setUser] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [form, setForm] = useState({
    name: "",
    mobile: ""
  });

  const topBar = useContext(TopBarContext);

  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const photoInputRef = useRef(null);

  const userId = useSelector(state => state.authState.firestoreUser.uid);

  const editModal = useModal();

  useEffect(() => {
    setForm({
      name: user && user.name,
      mobile: user && user.phone
    });
  }, [user]);

  useEffect(() => {
    let ignore = false;
    let unsubscribe = firestoreRef
      .collection("users")
      .doc(userId)
      .onSnapshot(doc => {
        setUser(doc.data());
      });
    const fetchData = async () => {
      let result = await getTransactions();
      if (!ignore) {
        setTransactions(result);
      }
      ignore = true;
    };
  }, [userId]);

  const updateUserInformation = () => {
    editModal.open();
  };

  const resetState = () => {
    setForm({ name: "", mobile: "" });
    setLoading(false);
  };

  const EditModal = () => {
    const submit = async e => {
      e.preventDefault();
      setLoading(true);
      try {
        let profileImageUrl = user && user.photo_url;
        if (selectedImage) {
          profileImageUrl = await uploadImageToStorage(
            selectedImage,
            selectedImage.name
          );
        }
        const formData = {
          name: form.name,
          phone: form.mobile,
          photo_url: profileImageUrl
        };
        await updateProfileData(userId, formData);
        resetState();
        editModal.close();
      } catch (err) {
        alert(err);
      } finally {
        setLoading(false);
      }
    };

    function handleInput(event) {
      setForm(
        Object.assign(form, {
          [event.target.name]: event.target.value
        })
      );
    }

    function openBrowseWindow() {
      photoInputRef.current.click();
    }

    return (
      <Modal {...editModal.props}>
        <ModalCard>
          <Row justify="space-between">
            <h4>Update your information</h4>
            <CloseIcon
              style={{ cursor: "pointer" }}
              onClick={() => editModal.close()}
            />
          </Row>

          <form onSubmit={submit}>
            <Col style={{ alignItems: "center", marginTop: 16 }}>
              <ProfilePic
                onPress={openBrowseWindow}
                selectedImage={selectedImage}
                user={user}
              />
              <input
                ref={photoInputRef}
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                onChange={e => {
                  if (e.target.files.length !== 0) {
                    const file = e.target.files[e.target.files.length - 1];
                    setSelectedImage(file);
                  }
                }}
                style={{ display: "none" }}
              />
            </Col>

            <Input
              type="text"
              label="Name"
              name="name"
              onChange={handleInput}
              defaultValue={user && user.name}
              margin="normal"
            />
            <Input
              label="Mobile"
              name="mobile"
              type="number"
              onChange={handleInput}
              defaultValue={user && user.phone}
              margin="normal"
            />
            <PrimaryButton
              type="submit"
              style={{ marginTop: 16 }}
              loading={loading}
            >
              UPDATE
            </PrimaryButton>
          </form>
        </ModalCard>
      </Modal>
    );
  };

  function handleOnClick() {
    if (!isVerified()) {
      topBar.show("warning", "This is a warning", "Click here to verify", true);
    } else {
      return true;
    }
  }

  const handleCheckButton = () => {
    //eslint-disable-next-line
    history.push("/result");
  };

  return (
    <React.Fragment>
      <BannerContainer>
        <PresentPage>
          <Title style={{ color: "white" }}>Profile</Title>
          <SubTitle>Your profile info</SubTitle>
        </PresentPage>
      </BannerContainer>
      <Page>
        <Container>
          {user ? (
            <>
              <Grid container>
                <Row flexDirection="column">
                  <Grid item xs={12}>
                    <Card margin="0" padding="0" radius="9px">
                      <Row>
                        <Col display="none">
                          <ProfilePicture
                            alt="Profile Picture"
                            src={user.photo_url}
                          />
                        </Col>
                        <Col style={{ marginLeft: "34px" }}>
                          <Row>
                            <Title>{user.name}</Title>
                          </Row>
                          <Col padding="0" style={{ overflow: "auto" }}>
                            <Row align="center">
                              <span onClick={handleOnClick}>Name:</span>
                              <UserDetail>{user.email}</UserDetail>
                            </Row>
                            <Row align="center">
                              <span>Roll No:</span>
                              <UserDetail>{user.roll}</UserDetail>
                            </Row>
                            <Row>
                              <span>Mobile:</span>
                              <UserDetail>{user.phone}</UserDetail>
                            </Row>
                            <Separator />
                            <Col padding="0">
                              <Row>
                                <Col alignitems="center">
                                  <Typography variant="caption">
                                    Exams appeared
                                  </Typography>
                                  <FancyLabel color={color.darkOrange}>
                                    {user.examsAppeared || "0"}
                                  </FancyLabel>
                                </Col>

                                <Col alignitems="center">
                                  <Typography variant="caption">
                                    Exams Passed
                                  </Typography>
                                  <FancyLabel color={color.lightSeaGreen}>
                                    {user.examsPassed || "0"}
                                  </FancyLabel>
                                </Col>

                                <Col alignitems="center">
                                  <Typography variant="caption">
                                    Exams Failed
                                  </Typography>
                                  <FancyLabel color={color.crimson}>
                                    {user.examsFailed || "0"}
                                  </FancyLabel>
                                </Col>

                                <Col alignitems="center">
                                  <Typography variant="caption">
                                    Passed Percentage
                                  </Typography>
                                  <FancyLabel color={color.teal}>
                                    {user.percentage || "0"}
                                  </FancyLabel>
                                </Col>
                              </Row>
                              <Row>
                                <PrimaryButton onClick={updateUserInformation}>
                                  Edit
                                </PrimaryButton>
                              </Row>
                            </Col>
                          </Col>
                        </Col>
                      </Row>
                    </Card>
                  </Grid>
                  <VerticalSeparator width="3px" />
                  <Card
                    margin="0px"
                    radius="9px"
                    style={{ height: "100%", justifyContent: "center" }}
                  >
                    <Col alignitems="center" justify="space-between">
                      <Typography variant="h6" align="center">
                        Your Available Points
                      </Typography>
                      <WalletButton
                        style={{ marginTop: 20 }}
                        variant="contained"
                        // onClick={handleCheckButton}
                      >
                        {user.wallet}
                      </WalletButton>
                    </Col>
                    <Row>
                      <PrimaryButton onClick={() => history.push("/pricing")}>
                        Go to Topup
                      </PrimaryButton>
                    </Row>
                  </Card>
                </Row>
              </Grid>

              <Row flexDirection="column">
                {/* <TopResult style={{ flex: 1 }} /> */}
                <Card style={{ flex: 2, width: "100%" }}>
                  <Row justify="space-between" style={{ paddingBottom: 16 }}>
                    <Title
                      onClick={() =>
                        topBar.show(
                          "warning",
                          "This is a warning",
                          "Click here to verify"
                        )
                      }
                    >
                      Transactions
                    </Title>
                    {/* <Title
                      style={{
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                      // TODO: Route to a screen to see all transactions
                      onClick={null}
                    >
                      View All
                    </Title> */}
                  </Row>
                  {transactions.length === 0 && (
                    <Typography variant="caption">
                      {" "}
                      You have no transactions.
                    </Typography>
                  )}
                  {transactions.map(transaction => {
                    return (
                      <TransactionCard key={transaction.key}>
                        <Row justify="space-between">
                          <span>Detail:</span>
                          <span>{transaction.detail}</span>
                        </Row>
                        <Row justify="space-between">
                          <span>Type:</span>
                          <span>{transaction.type}</span>
                        </Row>
                        <Row justify="space-between">
                          <span>Exams:</span>
                          <span>{transaction.value}</span>
                        </Row>
                      </TransactionCard>
                    );
                  })}
                </Card>
              </Row>
            </>
          ) : (
            <FullScreenLoader />
          )}
        </Container>
      </Page>
      <EditModal />
    </React.Fragment>
  );
}
const ProfilePicture = styled(Avatar)`
  && {
    height: 120px;
    width: 120px;
  }
`;

export const ModalCard = styled(Card)`
  &&&& {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const UserDetail = styled.span`
  margin-left: 3px;
`;

export default Profile;
